import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import { TbArrowBadgeRightFilled } from "react-icons/tb";
import { TbArrowBadgeRight } from "react-icons/tb";

function HowTraining() {


    let howArraay = [
        {
            description: 'Зареєструйся на сайті, щоб долучитися до програми — участь безоплатна.\n'
        },
        {
            description: 'Отримуй посилання з доступом до вебінарів та інших онлайн-активностей напередодні заходу.'
        },
        {
            description: 'Долучайся до онлайн-форматів, опановуй нові навички, бери участь у дискусіях і став запитання експертам.'
        }
    ]

    return (
        <section className="relative pb-10" id="ebaut">
            <div className="container w-[90%] max-w-screen-lg mx-auto">
                <div className="mb-10">
                    {/*<ScrollAnimation animateIn="animate__fadeInUp"><h6 className="bg-[#F3FF80] w-max px-3 py-1 mb-4 rounded-2xl">Про івент</h6></ScrollAnimation>*/}
                    <ScrollAnimation animateIn="animate__fadeInUp">
                        <h2 className="sm:text-4xl text-2xl mb-4 uppercase title-design before:bg-[#AF00A9]/30 after:bg-[#AF00A9]/30 w-full max-w-max mx-auto"><span>Як проходить навчання</span></h2>
                    </ScrollAnimation>
                </div>
                <div className="sm:grid grid-cols-3 gap-4 mb-10">
                    {
                        howArraay?.map((item, index) => (
                            <div className="flex items-center">
                                <div className="max-sm:mb-5" key={index}>
                                    <ScrollAnimation animateIn="animate__fadeInUp" className="text-center mb-2 text-3xl font-bold">
                                        {index+1}
                                    </ScrollAnimation>
                                    <ScrollAnimation animateIn="animate__fadeInUp" className="text-center sm:px-5">{item.description}</ScrollAnimation>
                                </div>
                                {
                                    index<2 ? <div className="text-4xl flex text-[#AF00A9] max-sm:hidden"><TbArrowBadgeRightFilled /><TbArrowBadgeRight className="-ml-3" /></div> : ''
                                }
                            </div>
                        ))
                    }
                </div>
                <ScrollAnimation className="max-sm:text-center text-center" animateIn="animate__fadeInUp"><b>Мова — українська. Передбачений переклад жестовою мовою</b></ScrollAnimation>
            </div>
        </section>
    )
}

export default HowTraining